module.exports = __webpack_public_path__ + "static/media/2-6.8de3162b.webp";